var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PlateTitle',{attrs:{"title":"申请邀约函"}}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_vm._v(" 123 ")]),_c('div',{staticClass:"know"},[_c('a-checkbox',{staticClass:"checkbox",on:{"change":_vm.handleKenwChange}},[_vm._v(" 我已阅读并同意"),_c('b',[_vm._v("《投标保函申请邀约函》")])])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }